import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";
import _get from "lodash/get";
import _debounce from "lodash/debounce";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Credit card search with autocomplete.
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import analytics from '@nerdwallet/analytics';
import { Impression } from '@nerdwallet/analytics/react/impression';
import { Tracking } from '@nerdwallet/nw-client-lib';
import { getLegacyId, getImageAltText, getName } from '@nerdwallet/marketplace/selectors/credit-cards';
import { getImageBySize } from '@nerdwallet/marketplace/utils';
import AutocompleteSearch from '../autocomplete-search/autocomplete-search';

var CreditCardSearch =
/*#__PURE__*/
function (_Component) {
  _inherits(CreditCardSearch, _Component);

  function CreditCardSearch(props) {
    var _this;

    _classCallCheck(this, CreditCardSearch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CreditCardSearch).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onImageError", function (e) {
      e.target.src = 'https://www.nerdwallet.com/cdn/cc/cc_generic_bw.png';
      e.target.onError = null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchInput", function (value) {
      // Only search if value isn't empty string to maintain completely empty results on empty search
      if (value.length > 0) {
        _this.logSearchInput(value);

        _this.searchCards(value);
      }

      _this.setState({
        inputValue: value
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (card, index, e) {
      var cardID = getLegacyId(card); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      if (_this.props.analytics.enabled) {
        analytics.track("credit_card_search_updated", {
          form_name: _get(_this.props, "analytics.payload.formName"),
          value_s: _get(card, 'id'),
          was_prefilled: false
        });
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      _this.props.onClick(cardID, card, e);

      _this.logSearchClick(cardID);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "logSearchInput", function (value) {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var formName = "credit-card-search".concat(_this.props.trackingPostfix); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var fieldName = "credit-card-search".concat(_this.props.trackingPostfix);
      Tracking.formInputChanged({
        formName: formName,
        fieldName: fieldName,
        fieldValue: value,
        inputType: 'TEXT'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "logSearchClick", function (cardID) {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var elementName = "credit-card-search-result".concat(_this.props.trackingPostfix); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var sectionCategory = "credit-card-search".concat(_this.props.trackingPostfix);
      Tracking.elementInteraction({
        elementName: elementName,
        sectionCategory: sectionCategory,
        elementContent: cardID,
        interactionType: 'CLICK'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderRow", function (card) {
      return React.createElement("div", {
        className: "autocomplete-search-result"
      }, React.createElement("div", {
        className: "autocomplete-search-result__image-container"
      }, React.createElement("img", {
        className: "autocomplete-search-result__image",
        src: getImageBySize(card),
        alt: getImageAltText(card),
        onError: _this.onImageError
      })), React.createElement("div", {
        className: "autocomplete-search-result__name-container"
      }, React.createElement("span", {
        className: "autocomplete-search-result__name",
        dangerouslySetInnerHTML: {
          __html: getName(card)
        }
      })));
    });

    _this.state = {
      results: [],
      inputValue: '',
      isLoading: false
    };
    _this.handleSearchInput = _debounce(_this.handleSearchInput.bind(_assertThisInitialized(_assertThisInitialized(_this))), 150);
    return _this;
  }

  _createClass(CreditCardSearch, [{
    key: "searchCards",
    // eslint-disable-next-line react/sort-comp -- directive added automatically by Shepherd migration
    value: function searchCards(value) {
      var _this2 = this;

      this.setState({
        isLoading: true
      }); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      this.props.marketplaceSDK.getAutocompleteData(_objectSpread({}, this.props, {
        productType: 'credit_cards',
        query: value,
        serverRequest: null
      })).then(function (data) {
        return _this2.setState({
          isLoading: false,
          results: _get(data, 'data.offers', [])
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var results = this.state.results.slice(0, this.props.maxResults); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var showNoCardMessage = this.state.inputValue.length > 0 && this.state.results.length === 0;
      return React.createElement(Impression, {
        entityName: _get(this.props, "analytics.payload.entityName") || "credit_card_search",
        eventType: "form_impression",
        payload: {
          form_name: _get(this.props, "analytics.payload.formName"),
          section_name: _get(this.props, "analytics.payload.sectionName")
        } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        enabled: this.props.analytics.enabled
      }, React.createElement(AutocompleteSearch // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      , {
        analytics: this.props.analytics // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        disableAutofocus: this.props.disableAutofocus,
        label: "Card Search" // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        maxResults: this.props.maxResults,
        onChange: this.handleSearchInput,
        onClick: this.handleClick // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        onKeyDown: this.props.onKeyDown // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        placeholder: this.props.placeholder,
        primaryKeyPath: "details.legacy_id.value",
        renderRow: this.renderRow,
        results: results,
        showNoCardMessage: showNoCardMessage // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        trackingPostfix: this.props.trackingPostfix // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        isLoading: this.state.isLoading
      }));
    }
  }]);

  return CreditCardSearch;
}(Component);

_defineProperty(CreditCardSearch, "displayName", 'Credit Cards Search');

_defineProperty(CreditCardSearch, "propTypes", {
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      formName: PropTypes.string,
      sectionName: PropTypes.string
    })
  }),
  disableAutofocus: PropTypes.bool,
  marketplaceSDK: PropTypes.shape({
    getAutocompleteData: PropTypes.func
  }).isRequired,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  trackingPostfix: PropTypes.string,
  maxResults: PropTypes.number,
  namedQueryName: PropTypes.string,
  // eslint-disable-line react/no-unused-prop-types
  searchKeys: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  sourceFields: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  sortKeys: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  isFuzzy: PropTypes.bool // eslint-disable-line  react/no-unused-prop-types

});

_defineProperty(CreditCardSearch, "defaultProps", {
  analytics: {
    enabled: false,
    payload: {
      formName: "credit_card_search"
    }
  },
  disableAutofocus: false,
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  placeholder: 'Search card name',
  trackingPostfix: '',
  maxResults: 10,
  namedQueryName: 'cc_autocomplete_active',
  searchKeys: ['offer.product.name', 'offer.product.institution.name', 'offer.details.slug'],
  sourceFields: ['offer.details.image_alt_text', 'offer.details.image_source', 'offer.details.image_source_medium', 'offer.details.image_source_small', 'offer.details.legacy_id', 'offer.id', 'offer.product.name'],
  sortKeys: ['offer.details.popularity_rank'],
  isFuzzy: true
});

export default CreditCardSearch;